export default __webpack_public_path__ + "static/media/close-session.min.27451a26.txt";